import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { DashboardIndicadores } from '../../dashboard.model';

@Injectable({ providedIn: 'root' })
export class DashboardIndicadoresSemanaisService {
    private url = `${environment.managerURL}/dashboard`;

    constructor(private http: HttpClient) {}

    getIndicadoresSemanais(): Observable<DashboardIndicadores> {
        return this.http.get<DashboardIndicadores>(`${this.url}/indicadores-semanais`);
    }
}
